import { render, staticRenderFns } from "./newProductSelect.vue?vue&type=template&id=c265885e&scoped=true"
import script from "./newProductSelect.vue?vue&type=script&lang=js"
export * from "./newProductSelect.vue?vue&type=script&lang=js"
import style0 from "./newProductSelect.vue?vue&type=style&index=0&id=c265885e&prod&lang=less&scoped=true"
import style1 from "./newProductSelect.vue?vue&type=style&index=1&id=c265885e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c265885e",
  null
  
)

export default component.exports